import type {ExtensionInfo} from '~/core/program';

import {Command} from '~/core/config';
import {VERSION, YFM_CONFIG_FILENAME} from '~/constants';
import {BaseProgram, withConfigDefaults} from '~/core/program';

import {Build} from './build';
import {Content} from './content';
import {Init} from './init';
import {Publish} from './publish';
import {Translate} from './translate';
import {NAME, USAGE, options} from './config';

export type {EntryInfo, SearchProvider, SearchServiceConfig} from './build';

export {parse} from './parser';
export {
    Build,
    Run as BuildRun,
    getHooks as getBuildHooks,
    getSearchHooks,
    getEntryHooks,
} from './build';
export {Publish, Run as PublishRun, getHooks as getPublishHooks} from './publish';
export {Translate, getHooks as getTranslateHooks} from './translate';
export {Content} from './content';
export {Init} from './init';

@withConfigDefaults(() => ({
    extensions: [] as ExtensionInfo[],
}))
export class Program extends BaseProgram {
    readonly name = 'Program';

    readonly command: Command = new Command(NAME)
        .helpOption(true)
        .allowUnknownOption(false)
        .version(VERSION, '--version', 'Output the version number')
        .usage(USAGE);

    readonly build = new Build(undefined, {isDefaultCommand: true});

    readonly content = new Content();

    readonly initProject = new Init();

    readonly publish = new Publish();

    readonly translate = new Translate();

    readonly options = [
        options.input('./'),
        options.config(YFM_CONFIG_FILENAME),
        options.extensions,
        options.quiet,
        options.strict,
        options.jobs,
        options.workerMaxOldSpace,
        options.copyOnWrite,
        options.originAsInput,
    ];

    protected readonly modules = [
        this.build,
        this.content,
        this.initProject,
        this.publish,
        this.translate,
    ];
}
